import Drawer from 'Components/Drawer';
import Panel from 'Components/Panel';
import { actions as deviceActions } from 'ducks/devices';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import icons from 'utils/ui/icons';
import CleanMeasurementData from './CleanMeasurementData';
import Table from './Table';

const Component = props => {
    const { device } = props;

    const [drawer, setOpenDrawer] = useState(null);
    const closeDrawer = () => setOpenDrawer(null);

    const submitting = useSelector(state => state.devices.submitting);

    let buttons = [];

    const dispatch = useDispatch();
    const { cleanMeasurementData, deleteFuture } = ({
        cleanMeasurementData: (id, from, to, callback) => dispatch(deviceActions.cleanMeasurementData(id, from, to, callback)),
        deleteFuture: id => dispatch(deviceActions.deleteFuture(id))
    });

    if (device.new_wise_box) {
        buttons = [
            {
                icon: icons.debug,
                onClick: () => setOpenDrawer('deleteData'),
                tooltip: 'Delete measurement data'
            }
        ];
    } else if (device.old_wise_box) {
        buttons = [
            {
                icon: icons.bug,
                confirmationHeader: 'Delete Confirmation',
                confirmationText: 'Are you sure you want to delete future data?',
                submitting: submitting,
                onClick: () => deleteFuture(device.id),
                tooltip: 'Delete future data'
            }
        ];
    }

    let DrawerContent;
    if (drawer === 'deleteData') {
        DrawerContent = (
            <CleanMeasurementData cleanMeasurementData={cleanMeasurementData} device={device} onSave={closeDrawer} submitting={submitting}/>
        );
    }

    const panelFields = { buttons };

    let TableComponent = (
        <Table device={device}/>
    );

    return (
        <React.Fragment>
            <Panel {...panelFields}>
                {TableComponent}
            </Panel>
            <Drawer big={drawer === 'showIndicator'} onClose={closeDrawer} open={!!drawer}>
                {DrawerContent}
            </Drawer>
        </React.Fragment>
    );
};

export default Component;
